import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { api, RB100_LOGO } from "../lib/api";
import { Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/admin/login", { email, password });
      localStorage.setItem("rb100_admin_token", data.token);
      toast.success("تم تسجيل الدخول");
      navigate("/admin/dashboard");
    } catch (err) {
      const msg = err?.response?.data?.detail || "بيانات الدخول غير صحيحة";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-white flex flex-col">
      <Navbar />
      <div className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-md">
          <div className="text-center mb-10">
            <div className="mx-auto bg-black p-3 h-24 w-24 flex items-center justify-center mb-6">
              <img src={RB100_LOGO} alt="" className="h-full w-full object-contain" />
            </div>
            <div className="flex items-center justify-center gap-2 text-rb-red mb-3">
              <ShieldCheck className="w-5 h-5" />
              <span className="text-xs tracking-[0.4em] font-bold">ADMIN ACCESS</span>
            </div>
            <h1 className="font-heading text-3xl sm:text-4xl font-extrabold text-rb-ink">
              لوحة الإدارة
            </h1>
            <p className="text-rb-textMuted text-sm mt-3">
              للمشرفين المعتمدين فقط
            </p>
          </div>
          <form onSubmit={submit} className="space-y-5 bg-rb-surface border border-rb-border p-8" data-testid="admin-login-form">
            <div>
              <label className="block text-xs tracking-widest text-rb-textMuted uppercase mb-2">
                البريد الإلكتروني
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-email-input"
                placeholder="admin@rb100.com"
                required
                className="w-full bg-white border border-rb-border focus:border-rb-red focus:outline-none focus:ring-2 focus:ring-rb-red/20 px-4 py-3 text-rb-ink text-sm transition-colors placeholder:text-rb-textMuted/70"
              />
            </div>
            <div>
              <label className="block text-xs tracking-widest text-rb-textMuted uppercase mb-2">
                كلمة المرور
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password-input"
                placeholder="••••••••"
                required
                className="w-full bg-white border border-rb-border focus:border-rb-red focus:outline-none focus:ring-2 focus:ring-rb-red/20 px-4 py-3 text-rb-ink text-sm transition-colors placeholder:text-rb-textMuted/70"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="w-full bg-rb-red hover:bg-rb-redHover disabled:opacity-60 text-white font-bold py-3.5 transition-colors flex items-center justify-center gap-2"
            >
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "دخول"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
